<template>
    <div class="app-container">
        <div
        class="faq-container">
            <pang-title :text="$router.lang.get('客服 中心')" eng="Customer Service"/>
            <pang-article-detail
            :title="'['+FAQ_TYPE_CHOICES[faq.faq_type]+']'+faq.article.title"
            :create_at="faq.create_at"
            :content="faq.article.content"/>
        </div>
    </div>
</template>

<script>
import { PangTitle, PangArticleDetail } from '../../components'
import enums from '../../utils/enums.js'
import request from '../../api/request'
import message from '../../utils/message'

export default {
    name: 'Detail',
    components: {
        PangTitle,
        PangArticleDetail,
    },
    data () {
        return {
            FAQ_TYPE_CHOICES: enums.FAQ_TYPE_CHOICES,
            faq:  {
                id: 1,
                article: {
                    content: '',
                    title: ''},
                faq_type: 1,
                create_at: '',
            },
        };
    },
    methods: {
        getRecent (id) {
            let _this = this
            request.get('/faqs/' + id, {}, this).then(function (res) {
                if (res.status == 200) {
                    _this.faq = res.data
                }
                else if (res.status == 404) {
                    _this.$router.replace('/404')
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
    },
    mounted () {
        this.getRecent(this.$route.params.id)
    },
}
</script>

<style>
</style>
